import * as React from 'react';
import styled from "styled-components";
import {IconLogo} from "../components";
import {Title, SectionTitle} from "../styled"

const Content = styled.div`
  margin-top: 40px;
`;

const LogoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 20px;
  padding: 45px 10px;
  background: #F5F9FF;
  box-sizing: border-box;

  svg {
    width: 256px;
    height: 60px;
  }
`

const Text = styled.div`
  max-width: 860px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #4F4F51;
`

const Container = styled.div`
  margin: 0 auto;
  max-width: 1340px;
  opacity: 0;
  
  transition: opacity 1s;
  
  @media screen and (max-width: 1400px) {
    padding: 0 10px;
  }
  
  @media screen and (max-width: 768px) {
    padding: 0 10px;
    
    ${Text} {
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0.01em;
    }
  }
`;

/**
 * render landing page main section
 * @constructor
 */
export default function About(): React.ReactElement {
  const ref = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (ref.current?.style) {
      ref.current.style.opacity = '1'
    }
  }, []);

  return (
    <Container ref={ref}>
      <LogoBox>
        <IconLogo />
      </LogoBox>
      <Content>
        <SectionTitle>О компании</SectionTitle>
        <Title>
          Создано специально для
          <span>онлайн школ</span>
        </Title>
        <Text>
          При разработке платорфмы учитывался опыт
          и потребности владельцев онлайн школ,
          с суммарным годовым оборотом в 1 млрд рублей
        </Text>
      </Content>
    </Container>
  );
}
